import { render } from "./p-image.vue?vue&type=template&id=0ce59bd7&scoped=true"
import script from "./p-image.vue?vue&type=script&lang=js"
export * from "./p-image.vue?vue&type=script&lang=js"

import "./p-image.vue?vue&type=style&index=0&id=0ce59bd7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce59bd7"]])

export default __exports__